/**
 * Format number to display with specified decimal places
 * Returns '-' for null, undefined, or NaN values
 */
export const formatNumber = (
  num: number | null | undefined,
  decimalPlaces: number = 1
): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '-';
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  });
};

/**
 * Format number with unit, handling null values gracefully
 */
export const formatNumberWithUnit = (
  num: number | null | undefined,
  unit: string,
  decimalPlaces: number = 1
): string => {
  const formattedNum = formatNumber(num, decimalPlaces);
  return formattedNum === '-' ? '-' : `${formattedNum} ${unit}`;
};